export default __webpack_public_path__ + "static/media/distribution-banner.e82e4aeb.jpg";